import { narrowDown } from '/src/data/shop/itemSearchOption'


// ヘルシー食・たくぱく調整食・ケア食などカテゴリを返す.
export const findCategoryLabel = (category_code) => {
  const code = category_code
  // const code = (category_code == "healthy_large") ? category_code : category_code.split("_")[0];
  return narrowDown.itemCategories.find(item => item.code === code)
}

// おかず・ご飯付き・アラカルトなどサブカテゴリを返す.
export const findSubCategoryLabel = (category_code) => {
  const code = (category_code?.split("_")[1]) ? category_code?.split("_")[1] : category_code;
  return narrowDown.itemSubCategories.find(item => item.code === code)
}

// メイン＋サブカテゴリのラベルを返す.
export const findWithSubCategoryLabel = (category_code) => {
  return narrowDown.withSubCategories.find(item => item.code === category_code)
}